export default "__VITE_ASSET__7c097e3b__"